<section class="main-wrap telehealth-consent-wrap">
    <div class="sidebar-container sc-empty">
      <app-sidebar-empty></app-sidebar-empty>
    </div>
    <div class="content-container login-container telehealth-consent-container">
      <div class="row">
        <div class="col-md-12">
          <signature-form [examType]="examType" (signage)="setSignature($event)"></signature-form>
        </div>
      </div>
    </div>
</section>
